import React, { useRef, useState } from 'react';
import i18next from "../../i18n.js";
import { acceptAdditionalInputFileString, maxFileSize, allowedAdditionalFileExtensions, businessTripFolderSettiongs, acceptImageFileString } from "../../constants.js";
import { Button } from 'react-bootstrap';
import { getFileAttachmentErrorMessage } from '../helpers/CheckFunctions.js';
import { base64toBlob, getDodumentFiles } from '../helpers/HelperFunctions.js';
import { errorMessageDialog, viewFile, viewImage, unknownErrorMessageDialog, messageDialog, yesNoDialog } from '../ModalDialog.js';

const FileSelect = (props) => {
    const [loading, setLoading] = useState(false);
    const fileInputRef = useRef(null);

    const onAddFileClick = () => {
        if (!loading) {
            fileInputRef.current.click();
        }
    }

    const onFileAdded = (e) => {
        e.persist();
        setLoading(true);
        if (e.target.files && e.target.files.length > 0) {
            const errorMessage = getFileAttachmentErrorMessage(e.target.files[0], allowedAdditionalFileExtensions, maxFileSize);
            if (errorMessage) {
                errorMessageDialog(errorMessage);
                setLoading(false);
            }
            else {
                var fileReader = new FileReader();
                fileReader.addEventListener('load', () => {
                    const addedFile = {
                        title: e.target.files[0].name,
                        fileName: e.target.files[0].name,
                        mimeType: e.target.files[0].type,
                        isFolder: false,
                        content: fileReader.result.split(';base64,')[1]
                    }
                    fileInputRef.current.value = '';
                    const newValue = props.folderContent?.children ? structuredClone(props.folderContent.children) : [];
                    newValue.push(addedFile);
                    if (props.onChange) {
                        props.onChange({
                            target: {
                                name: props.title,
                                value: newValue
                            }
                        });
                    }
                    setLoading(false);
                }, false);
                fileReader.readAsDataURL(e.target.files[0]);
            }
        }
    }

    const onRemove = (index) => {
        if (props.onChange) {
            yesNoDialog(i18next.t('attentionTitle'), i18next.t('removeFileMessage'), async () => {
                props.onChange({
                    target: {
                        name: props.title,
                        value: props.folderContent.children.filter((_, i) => i !== index)
                    }
                });
            });
        }
    }

    const onLoadFileClick = (index) => {
        if (props.folderContent.children[index].nodeRef) {
            getDodumentFiles('/api/file/GetSignedFiles', [{
                nodeRef: props.folderContent.children[index].nodeRef,
                loadAsPdf: true
            }]).then(result => {
                if (result) {
                    let anchor = document.createElement("a")
                    anchor.href = result[0].file.content
                    anchor.download = result[0].file.fileName
                    anchor.click();
                }
                else {
                    unknownErrorMessageDialog();
                }
            });
        }
        else {
            const objectUrl = window.URL.createObjectURL(base64toBlob(props.folderContent.children[index].content, props.folderContent.children[index].mimeType));
            let anchor = document.createElement("a");
            anchor.href = objectUrl;
            anchor.download = props.folderContent.children[index].fileName;
            anchor.click();
        }
    }

    const onViewFileClick = (index) => {
        if (props.folderContent.children[index].nodeRef) {
            getDodumentFiles('/api/file/GetSignedFiles', [{
                nodeRef: props.folderContent.children[index].nodeRef,
                loadAsPdf: true
            }]).then(result => {
                if (result) {
                    if (result[0].file.mimeType == 'application/pdf') {
                        viewFile(result[0].file.content, result[0].file.fileName);
                    }
                    else if (acceptImageFileString.split(',').includes(result[0].file.mimeType)) {
                        viewImage(result[0].file.content);
                    }
                    else {
                        messageDialog('', i18next.t("document.notViewedMessage"));
                    }
                }
                else {
                    unknownErrorMessageDialog();
                }
            });
        }
        else {
            if (props.folderContent.children[index].mimeType == 'application/pdf') {
                viewFile(window.URL.createObjectURL(base64toBlob(props.folderContent.children[index].content, props.folderContent.children[index].mimeType)), props.folderContent.children[index].fileName);
            }
            else if (acceptImageFileString.split(',').includes(props.folderContent.children[index].mimeType)) {
                viewImage(window.URL.createObjectURL(base64toBlob(props.folderContent.children[index].content, props.folderContent.children[index].mimeType)));
            }
            else {
                messageDialog('', i18next.t("document.notViewedMessage"));
            }
        }
    }

    const settings = businessTripFolderSettiongs.find(s => s.title === props.title);

    return (<div className={'file-select-input' + (props.value ? ' selected' : '') + (props.generated ? ' generated' : '')}>
        <div className='file-select-header'>
            <div className='file-select-title'>{settings?.label}</div>
            {settings?.required && <div className='required-label'>{i18next.t('other.required')}</div>}
            {settings?.generated && <div className='generated-label'>{i18next.t('other.generatedBySystem')}</div>}
        </div>
        {props.description && <div className='file-select-description'>{props.description}</div>}
        <div className='file-select-body'>
            <input ref={fileInputRef} onChange={onFileAdded} accept={acceptAdditionalInputFileString} type='file' style={{ display: "none" }} />
            {props.folderContent?.children?.length > 0 && props.folderContent?.children.map((item, index) => <div className='file-select-file'>
                <div className='file-select-file-header'>
                    <div className='file-name'>{item.title}</div>
                    {!props.disabled && !settings?.generated && <div className='remove-btn' onClick={() => onRemove(index)} />}
                </div>
                <div className='file-select-btns'>
                    <Button className='load-btn' onClick={() => onLoadFileClick(index)} >{i18next.t('download')}</Button>
                    <Button className='view-btn' onClick={() => onViewFileClick(index)} >{i18next.t('view')}</Button>
                </div>
            </div>)}
            {!props.disabled && !settings?.generated && <Button onClick={onAddFileClick} >{i18next.t('addFile')}</Button>}
        </div>
    </div>);
}
export default FileSelect;